import React from "react";
import { graphql } from "gatsby";

const ArticleVideo = ({ video }) => {
  if (!video || !video.provider || !video.url) {
    return <p>No video available</p>;
  }

  const extractVideoID = () => {
    const { provider, url } = video;
    try {
      const urlObj = new URL(url);

      if (provider.toLowerCase() === "youtube") {
        // YouTube video ID can be in the `v` query param
        return urlObj.searchParams.get("v");
      } else if (provider.toLowerCase() === "vimeo") {
        // Vimeo video ID is the last segment of the pathname
        const pathParts = urlObj.pathname.split("/");
        return pathParts[pathParts.length - 1];
      } else {
        console.warn(`Unsupported video provider: ${provider}`);
        return null;
      }
    } catch (error) {
      console.error("Error parsing video URL:", error);
      return null;
    }
  };

  const videoID = extractVideoID();

  if (!videoID) {
    return <p>Invalid video URL</p>;
  }

  const iframeSrc =
    video.provider.toLowerCase() === "youtube"
      ? `https://www.youtube.com/embed/${videoID}`
      : `https://player.vimeo.com/video/${videoID}`;

  return (
    <section className="article-video">
      <div className="article-video__inner">
        <div className="article-video__content"></div>
        <div className="article-video__video">
          <iframe
            src={iframeSrc}
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            title="Article Video"
            className="article-video__iframe"
          ></iframe>
        </div>
      </div>
    </section>
  );
};

export default ArticleVideo;

export const query = graphql`
  fragment ArticleVideoProps on DatoCmsArticleVideo {
    id
    video {
      provider
      url
    }
  }
`;
